/**
 * Money is stored as integer paisa across the system. These helpers convert
 * between paisa, rupees (numeric), and string inputs (for forms).
 *
 *   100 paisa = 1 rupee
 *
 * Always round explicitly at conversion boundaries to avoid floating point
 * drift.
 */

/** Convert paisa to rupees (number). */
export function paisaToRupees(paisa: number): number {
  return paisa / 100;
}

/** Convert rupees (number) to paisa (integer). */
export function rupeesToPaisa(rupees: number): number {
  return Math.round(rupees * 100);
}

/**
 * Parse a free-text rupee amount (e.g., from a form input) into paisa.
 * Accepts "12,50,000", "1250000.50", "Rs. 1,250", etc.
 *
 * Returns null on unparseable input.
 */
export function parseRupeeInputToPaisa(input: string): number | null {
  if (input == null) return null;
  // Strip Rs. prefix, commas, and whitespace
  const cleaned = input.replace(/Rs\.?/i, '').replace(/,/g, '').trim();
  if (cleaned === '') return null;
  const rupees = Number(cleaned);
  if (!Number.isFinite(rupees) || rupees < 0) return null;
  return rupeesToPaisa(rupees);
}
